import * as React from 'react';

import * as styles from './JournalHighlightsSliderMobile.css';

interface IJournalHighlightsSliderMobileProps {
  children: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>[];
}

export function JournalHighlightsSliderMobile({ children }: IJournalHighlightsSliderMobileProps) {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['carousel']}>{children}</div>
    </div>
  );
}
